import Header from 'modules/header/components/header'
import React, { Suspense, useEffect, useRef, useState } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { useLocation } from 'react-use'
import withStorageContextProvider from 'react-storage-context'
import { compose } from 'recompose'
import entryPoint from 'shared/components/entry-point-hoc'
import ModalMessage from 'shared/components/message/modal-message'
import ContextManagers from 'shared/context-managers'
import channelSelectorItems from 'shared/redux/channel-selector'
import creationFilters from 'shared/redux/creation-filters'
import creationTool from 'shared/redux/creation-tool'
import draw from 'shared/redux/draw'
import { getDefaultStore } from 'shared/redux/init-store'
import { setUserPermissions } from 'shared/redux/permissions'
import { setUser } from 'shared/redux/user'
import { createGlobalStyle } from 'styled-components'
import DesktopGlobalCSS from '../css/global-css'
import { PromptMessages } from '../gif-maker/components/app'
import error from '../gif-maker/redux/error'
import slideshow from '../gif-maker/redux/slideshow'
import Background from './components/background'
import CreationToolsContextManager from './manager'
import CreationToolsRoute from './routes'

const store = getDefaultStore({ creationTool, channelSelectorItems, slideshow, error, draw, creationFilters })

const CreationGlobalStyles = createGlobalStyle`
    body {
        background-color: #000 !important;
    }
`

/**
 * Creation Tools
 * To update buttons, copy, etc. look in the /types directory.
 */
const CreationTools = props => {
    const { user, showSearch, showBrowse, permissions } = props
    const [showPrompt, setShowPrompt] = useState<boolean>(false)
    const messageRef = useRef<string>('')
    const navigateRef = useRef<(ok: boolean) => void>()
    const { pathname } = useLocation()
    const isSupercut = pathname?.indexOf('/supercut') === 0

    useEffect(() => {
        user && store.dispatch(setUser({ loggedIn: true, username: user.username, isStaff: user.is_staff }))
        store.dispatch(setUserPermissions(permissions))
    }, [user])

    return (
        <>
            <DesktopGlobalCSS />
            <Provider store={store}>
                <BrowserRouter
                    getUserConfirmation={(message, navigate) => {
                        messageRef.current = message
                        navigateRef.current = navigate
                        setShowPrompt(true)
                    }}
                >
                    <Suspense fallback={null}>
                        <ContextManagers>
                            <CreationToolsContextManager>
                                <>
                                    <CreationGlobalStyles />
                                    <Background />
                                    {!isSupercut && (
                                        <Header
                                            {...{
                                                user,
                                                showSearch,
                                                showBrowse,
                                            }}
                                        />
                                    )}
                                    <CreationToolsRoute {...props} />
                                    {showPrompt && (
                                        <ModalMessage
                                            onConfirm={() => {
                                                setShowPrompt(false)
                                                navigateRef.current && navigateRef.current(true)
                                            }}
                                            onCancel={() => {
                                                setShowPrompt(false)
                                                navigateRef.current && navigateRef.current(false)
                                            }}
                                            {...PromptMessages[messageRef.current]}
                                        />
                                    )}
                                </>
                            </CreationToolsContextManager>
                        </ContextManagers>
                    </Suspense>
                </BrowserRouter>
            </Provider>
        </>
    )
}

export default compose(entryPoint(store), withStorageContextProvider('giphy-desktop'))(CreationTools)
